import { Container, dispatcher, ingenuity, Linear } from "@quest/base-core";

import { GameParserModel } from "../Platform/GameParserModel";
import { StickyWildViewFG } from "./StickyWildViewFG";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { SoundConstantGame } from "../Constants/SoundConstantGame";
import { gameConstants } from "../Constants/gameConstants";

export class StickyWildControllerFG {
  private view: StickyWildViewFG;
  private wildReelFgMainContainer: Container;

  constructor(view: StickyWildViewFG) {
    this.view = view;
    this.view.visible = true;
    this.initializeComponents();
    this.subscribeEvents();
  }
  /**
   * to subscribe feature related events
   */
  private subscribeEvents(): void {
    this.unSubscribeEvents();
    dispatcher.on(eventDispatchers.SHOW_STICKY_WILD_ON_BROKEN, this.showStickyWildsOnBroken, this);
    dispatcher.on(eventDispatchers.SHOW_STICKY_WILD_ON_REEL_FG, this.showFullWildReel, this);
    dispatcher.on(eventDispatchers.PLAY_WILD_WIN_ANIM, this.playWinAnim, this)
    dispatcher.on(eventDispatchers.SUPSPEPND_WILD_WIN, this.stopWinWildAnim, this);
    dispatcher.on(eventDispatchers.SHOW_STATIC_STICKY_WILD, this.showStaticWild, this);
  }
  /**
   * to unsubscribe feature related events
   */
  private unSubscribeEvents(): void {
    dispatcher.off(eventDispatchers.SHOW_STICKY_WILD_ON_BROKEN, this.showStickyWildsOnBroken, this);
    dispatcher.off(eventDispatchers.SHOW_STICKY_WILD_ON_REEL_FG, this.showFullWildReel, this);
    dispatcher.off(eventDispatchers.PLAY_WILD_WIN_ANIM, this.playWinAnim, this)
    dispatcher.off(eventDispatchers.SUPSPEPND_WILD_WIN, this.stopWinWildAnim, this);
    dispatcher.off(eventDispatchers.SHOW_STATIC_STICKY_WILD, this.showStaticWild, this);

  }
  /**
   * to initialize fefature containers
   */
  private initializeComponents(): void {
    this.wildReelFgMainContainer = this.view.getContainerByID("WildReelFgMainContainer") as Container
  }
  /**
   * to show sticky wilds on reel in case on broken
   */
  private showStickyWildsOnBroken(): void {
    (ingenuity.parserModel as GameParserModel).getWildLockPos()[(ingenuity.parserModel as GameParserModel).getPickChoice()].forEach((reelNo: number, index: number) => {
      const reel = reelNo - 1;
      this.fadeInTopPanel(reel, 0)
      dispatcher.fireEvent(eventDispatchers.HIDE_REEL_BEHIND_WILD_FG, reel);
      const container: Container = this.view.cloneContainer(reel);
      let wildAnimation = this.view.cloneSpine();
      this.wildReelFgMainContainer.addChild(container);
      container.addChild(wildAnimation);
      wildAnimation.playAnim("static", false);
    })
  }
  /**
  * to show sticky wilds on reel 
  */
  private showFullWildReel(): void {
    this.cloneWildAnimContainer();
    (ingenuity.soundManager as any).playSound(SoundConstantGame.WILD_1X4_APPEAR, 1, false, gameConstants.SOUND_LIST_POSTLOAD);
    this.playWildLanding();
  }
  /**
   * to clone animtion
   */
  private cloneWildAnimContainer(): void {
    (ingenuity.parserModel as GameParserModel).getWildLockPos()[(ingenuity.parserModel as GameParserModel).getPickChoice()].forEach((reelNo: number, index: number) => {
      const reel = reelNo - 1;
      dispatcher.fireEvent(eventDispatchers.HIDE_REEL_BEHIND_WILD_FG, reel);
      const container: Container = this.view.cloneContainer(reel);
      let wildAnimation = this.view.cloneSpine();
      this.wildReelFgMainContainer.addChild(container);
      container.addChild(wildAnimation);
      wildAnimation.playAnim("static", false);
    })
  }
 
  /**
   * to play wild landing animations and start fg spins
   */
  private playWildLanding(): void {
    let stickyPos = (ingenuity.parserModel as GameParserModel).getWildLockPos()[(ingenuity.parserModel as GameParserModel).getPickChoice()]
    stickyPos.forEach((reelNo: number, index: number) => {
      
      const reel = reelNo - 1;
      this.fadeInTopPanel(reel, 400);
      let animContainer = this.view.getContainerByID("WildReelContainer_" + reel)
      animContainer.children[0].playAnim("landing", false);
      animContainer.children[0].onComplete.addOnce(() => {
        (ingenuity.soundManager as any).playSound(SoundConstantGame.FS_WILD_1X4_LOCK, 1, false, gameConstants.SOUND_LIST_POSTLOAD);
        animContainer.children[0].playAnim("static", true);
        if (index === stickyPos.length - 1) {
          dispatcher.fireEvent(eventDispatchers.START_FG_FIRST_SPIN);
        }
      })
    })
  }

  private fadeInTopPanel(reelNo: number, duration: number): void{
    const topPanel = this.view.getImageById(`wildTopPanel_${(reelNo)}`);
    topPanel.alpha = 0;
    topPanel.visible = true;
    const fadeInTween = ingenuity.currentGame.add.tween(topPanel);
    fadeInTween
    .to({alpha: 1}, 400, Linear.None)
    .start()
    .onComplete.addOnce(()=>{
      ingenuity.currentGame.tweens.remove(fadeInTween);
    })
  }
  /**
   * to play wild win animation in case of winning on wild symbol
   */
  private playWinAnim(): void {
    (ingenuity.parserModel as GameParserModel).getWildLockPos()[(ingenuity.parserModel as GameParserModel).getPickChoice()].forEach((reelNo: number, index: number) => {
      const winOffset: number[][] = (ingenuity.parserModel as GameParserModel).getLinesWinAllUniquePositions()
      for (let index = 0; index < winOffset.length; index++) {
        if ((reelNo - 1) == winOffset[index][0]) {
          const WildReelContainer: Container = this.view.getContainerByID("WildReelContainer_" + (reelNo - 1));
          (ingenuity.soundManager as any).playSound(SoundConstantGame.WILD_1X4_WIN, 1, false, gameConstants.SOUND_LIST_POSTLOAD);
          WildReelContainer.children[0].onComplete.dispose();
          WildReelContainer.children[0].playAnim("win_with_winframe", true);
          break;
        }
      }
    }
    )
  }
  /**
   * to stop wild win and start idle anim
   */
  private stopWinWildAnim(): void {
    this.wildReelFgMainContainer.forEach((animContainer: Container) => {
      animContainer.children[0].playAnim("static", true);
    })
  }
  /**
   * to show static symbol at the time of freegame outro
   */
  private showStaticWild(): void {
    this.wildReelFgMainContainer.forEach((animContainer: Container) => {
      animContainer.children[0].playAnim("static", true);
    })
  }
  /**
   * to reset feature 
   */
  public resetStickyWild(): void {
    this.unSubscribeEvents();
    this.view.getContainerByID("WildReelTopPanelContainer").children.forEach((child) =>{
      child.visible = false;
    })
    this.wildReelFgMainContainer.removeChildren();
    this.wildReelFgMainContainer.children = [];
  }
}